function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M244.405 362.405c68.73 0 124.448-11.779 124.448-26.308 0-14.53-55.717-26.308-124.448-26.308v52.616",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.405 362.405c68.73 0 124.448-11.779 124.448-26.308 0-14.53-55.717-26.308-124.448-26.308v52.616",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M257.477 487.753h.309v11.783h-.309z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M257.477 487.753h.309v11.783h-.309z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.739 501.898c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787H236.74",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.739 501.898c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787H236.74",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.615 501.898c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787h-82.034",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.615 501.898c0-15.899 18.364-28.787 41.017-28.787 22.653 0 41.017 12.888 41.017 28.787h-82.034",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 257.632,
  cy: 386.976,
  rx: 79.18,
  ry: 101.897,
  fill: "#000"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 257.632,
  cy: 386.976,
  rx: 79.18,
  ry: 101.897,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.594,
  cy: 384.771,
  rx: 41.017,
  ry: 74.981,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 291.594,
  cy: 384.771,
  rx: 41.017,
  ry: 74.981,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.946 250.9c22.684 12.713 24.297 35.784 3.603 51.53-20.693 15.747-55.857 18.206-78.541 5.493-22.684-12.714-24.297-35.785-3.604-51.531 20.694-15.747 55.858-18.206 78.542-5.493",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.946 250.9c22.684 12.713 24.297 35.784 3.603 51.53-20.693 15.747-55.857 18.206-78.541 5.493-22.684-12.714-24.297-35.785-3.604-51.531 20.694-15.747 55.858-18.206 78.542-5.493",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M260.683 266.886c2.565 2.127 2.825 5.848.581 8.312-2.244 2.463-6.142 2.736-8.707.609-2.565-2.127-2.825-5.849-.581-8.312 2.244-2.463 6.142-2.736 8.707-.609",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260.683 266.886c2.565 2.127 2.825 5.848.581 8.312-2.244 2.463-6.142 2.736-8.707.609-2.565-2.127-2.825-5.849-.581-8.312 2.244-2.463 6.142-2.736 8.707-.609",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M363.01 369.532a7.461 7.461 0 015.276-9.138l.962-.257a7.461 7.461 0 113.862 14.414l-.962.257a7.461 7.461 0 01-9.138-5.276z",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M363.01 369.532h0a7.461 7.461 0 015.276-9.138s0 0 0 0l.962-.257a7.461 7.461 0 019.138 5.275h0a7.461 7.461 0 01-5.275 9.138s0 0 0 0l-.963.258a7.461 7.461 0 01-9.138-5.276s0 0 0 0z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.93 376.203l52.45-14.054a9 9 0 0111.024 6.364l1.73 6.46a9 9 0 01-6.363 11.022L351.32 400.05a9 9 0 01-11.023-6.364l-1.73-6.46a9 9 0 016.363-11.023z",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.93 376.203l52.45-14.054a9 9 0 0111.024 6.364l1.73 6.46a9 9 0 01-6.363 11.022s0 0 0 0L351.32 400.05a9 9 0 01-11.023-6.364l-1.73-6.46a9 9 0 016.363-11.023s0 0 0 0z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M358.527 352.8l-6.406-23.906a7.96 7.96 0 0115.376-4.12l6.406 23.907a7.96 7.96 0 01-15.376 4.12z",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358.527 352.8l-6.406-23.906a7.96 7.96 0 015.628-9.748s0 0 0 0h0a7.96 7.96 0 019.749 5.628l6.405 23.907a7.96 7.96 0 01-5.628 9.748s0 0 0 0h0a7.96 7.96 0 01-9.748-5.628z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M205.969 369.619c84.957 22.764 156.877 29.84 160.637 15.807 3.76-14.035-62.062-43.866-147.02-66.63l-13.617 50.823",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.969 369.619c84.957 22.764 156.877 29.84 160.637 15.807 3.76-14.035-62.062-43.866-147.02-66.63l-13.617 50.823",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M149.576 254.6c.8 18.525 35.795-.988 35.795-.988s-36.596-17.538-35.795.987z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.576 254.6c.8 18.525 35.795-.988 35.795-.988s-36.596-17.538-35.795.987z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M187.412 201.129c-15.287 10.496 19.806 29.833 19.806 29.833s-4.52-40.33-19.806-29.833z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.412 201.129c-15.287 10.496 19.806 29.833 19.806 29.833s-4.52-40.33-19.806-29.833z",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M164.12 501.899h208.246"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M326.357 281.073c16.52 10.198 15.288 24.28-2.752 31.455-18.04 7.174-46.057 4.723-62.578-5.475-16.52-10.198-15.288-24.28 2.752-31.455 18.04-7.174 46.057-4.723 62.578 5.475",
  fill: "#797979"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.357 281.073c16.52 10.198 15.288 24.28-2.752 31.455-18.04 7.174-46.057 4.723-62.578-5.475-16.52-10.198-15.288-24.28 2.752-31.455 18.04-7.174 46.057-4.723 62.578 5.475",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M251.47 291.034l84.323 7.378"
}))));

var SvgGame = function SvgGame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "146.063 195.885 267.881 310.514"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/game.8cccc6c4.svg";
export { SvgGame as ReactComponent };